import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// 1. Ant Design
import { Alert, Form, Input, Modal } from "antd";
// 2. External libraries
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import styles from "@/styles/Company/Settlements.module.less";
/**
 * Модалка с обязательной причиной — общая для сторно оплаты (UC1121) и аннулирования счёта (UC1123).
 * Причина обязательна и не короче 3 символов, кнопка подтверждения недоступна, пока условие не выполнено.
 */
const ReasonModal = observer(({ open, title, label = "Причина", submitText, testId, loading, error, onSubmit, onCancel }) => {
    const [form] = Form.useForm();
    const reason = Form.useWatch("reason", form);
    const isValid = typeof reason === "string" && reason.trim().length >= 3;
    useEffect(() => {
        if (open)
            form.resetFields();
    }, [open]);
    const handleOk = async () => {
        const values = await form.validateFields().catch(() => null);
        if (!values)
            return;
        const ok = await onSubmit(values.reason.trim());
        if (ok)
            onCancel();
    };
    return (_jsxs(Modal, { open: open, title: title, okText: submitText, cancelText: "\u041E\u0442\u043C\u0435\u043D\u0430", onOk: handleOk, onCancel: onCancel, okButtonProps: { danger: true, loading, disabled: !isValid, "data-testid": testId }, destroyOnHidden: true, children: [error ? (_jsx(Alert, { type: "error", showIcon: true, message: error.text, "data-error-code": error.code ?? undefined, className: styles.notice })) : null, _jsx(Form, { form: form, layout: "vertical", children: _jsx(Form.Item, { name: "reason", label: label, rules: [
                        { required: true, whitespace: true, message: "Укажите причину" },
                        { min: 3, message: "Минимум 3 символа" },
                    ], children: _jsx(Input.TextArea, { autoSize: { minRows: 2, maxRows: 4 }, maxLength: 500, showCount: true }) }) })] }));
});
ReasonModal.displayName = "ReasonModal";
export default ReasonModal;
